import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';

const DAY_IN_MILLISECONDS = 86400000;

@Injectable({ providedIn: 'root' })
@Pipe({ name: 'dateTime' })
export class DateTimePipe implements PipeTransform {
    // to avoid showing 00:00 in date without time
    transform(value: string): string {
        const dateTime = new Date(value);
        const isDateWithTime = dateTime.getTime() % DAY_IN_MILLISECONDS !== 0;
        if (isDateWithTime) {
            return formatDate(value, 'dd.MM.yyyy HH:mm', 'en-US');
        } else {
            return formatDate(value, 'dd.MM.yyyy', 'en-US');
        }
    }
}
